import { set as lodashSet } from 'lodash/fp';
import tb from 'ts-toolbelt';

export function set<
  TObject extends Record<string, unknown>,
  TPath extends string
>(
  obj: TObject,
  path: tb.Function.AutoPath<TObject, TPath>,
  value: TObject[TPath],
): TObject {
  return lodashSet(path, value, obj);
}
